import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import TablePagination from '@material-ui/core/TablePagination';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import withWidth from '@material-ui/core/withWidth';

import StockDetail from '../mobile/StockDetail'
import BColor from '../BColor'
import ExposureZero from '@material-ui/icons/Clear'
import BigSmallSetting from './BigSmallSetting';

import Typography from '@material-ui/core/Typography';
import BigSmallList from './BigSmallList';
import BigSmallList1 from './BigSmallList1';

import MyLoveList from '../mylove/MyLoveList';
import FavoriteBorder from '@material-ui/icons/Build'

import {exportExcel} from '../util/ExportCSV'
import Divider from '@material-ui/core/Divider';

function desc(a, b, orderBy) {
    if (b.chip != undefined && a.chip != undefined && orderBy != "" && b.chip[orderBy] < a.chip[orderBy]) {
        return -1;
    }
    if (b.chip != undefined && a.chip != undefined && orderBy != "" && b.chip[orderBy] > a.chip[orderBy]) {
        return 1;
    }

    return 0;
}


function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) =>
        [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'name', numeric: false, disablePadding: false, label: '股票代號', sid: 'name' },

    { id: 'ymd', numeric: false, disablePadding: false, label: '日期', sid: 'ymd' },
    { id: 'all', numeric: false, disablePadding: false, label: '股票張數', sid: 'all' },
    { id: 'sinc', numeric: false, disablePadding: false, label: '股票增減', sid: 'sinc' },
    { id: 'user', numeric: false, disablePadding: false, label: '股東人數', sid: 'user' },
    { id: 'uinc', numeric: false, disablePadding: false, label: '人數增減', sid: 'uinc' },
    // { id: 'avgs', numeric: false, disablePadding: false, label: '平均張數/人', sid: 'avgs' },
    // { id: 'avginc', numeric: false, disablePadding: false, label: '上週增減', sid: 'avginc' },

    { id: 'biguser', numeric: false, disablePadding: false, label: '人數', sid: 'biguser' },
    { id: 'biguper', numeric: false, disablePadding: false, label: '佔全體股東', sid: 'biguper' },
    { id: 'bincp', numeric: false, disablePadding: false, label: '人數增減', sid: 'bincp' },
    { id: 'bigstock', numeric: false, disablePadding: false, label: '股票張數', sid: 'bigstock' },
    { id: 'bigsper', numeric: false, disablePadding: false, label: '持股比例', sid: 'bigsper' },
    { id: 'bigincp', numeric: false, disablePadding: false, label: '本週持股增減', sid: 'bigincp' },
    { id: 'b2incp', numeric: false, disablePadding: false, label: '近2週持股增減', sid: 'b2incp' },

    { id: 'cuser', numeric: false, disablePadding: false, label: '人數', sid: 'cuser' },
    { id: 'cuper', numeric: false, disablePadding: false, label: '佔全體股東', sid: 'cuper' },
    { id: 'cincp', numeric: false, disablePadding: false, label: '人數增減', sid: 'cincp' },
    { id: 'cstock', numeric: false, disablePadding: false, label: '股票張數', sid: 'cstock' },
    { id: 'csper', numeric: false, disablePadding: false, label: '持股比例', sid: 'csper' },
    { id: 'csincp', numeric: false, disablePadding: false, label: '本週持股增減', sid: 'csincp' },
    { id: 'c2incp', numeric: false, disablePadding: false, label: '近2週持股增減', sid: 'c2incp' },

    { id: 'love', numeric: false, disablePadding: false, label: '自選清單' },
];

const color1 = BColor.blue1color// "#e0757e"
const color2 = BColor.column
const color3 = BColor.blackcolor


function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleOk = () => {
        setOpen(false);
        props.freecashupdate()
    };

    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead style={{ background: color1 }}>

            <BigSmallSetting open={open} handleClose={handleClose} handleOk={handleOk}></BigSmallSetting>

            <TableRow style={{}}>
                <TableCell className={classes.stickya1} colSpan={1} style={{ color: "#FFFFFF", borderRight: '1px solid #dbdbdb' }}>股票名稱</TableCell>
                <TableCell className={classes.stickya} colSpan={5} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">總股東人數與股票張數
                    <Typography size="small" variant="caption" style={{ fontSize: 10, color: '#e8e8e8', marginLeft: 8 }} className={classes.button1} onClick={handleClickOpen}>
                        調整參數
                    </Typography>
                </TableCell>
                <TableCell className={classes.stickya} colSpan={7} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">大戶</TableCell>
                <TableCell className={classes.stickya} colSpan={7} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">散戶</TableCell>
                <TableCell className={classes.stickya} colSpan={1} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center"></TableCell>
            </TableRow>
            <TableRow style={{}}>
                {headCells.map(headCell => (
                    <TableCell
                        // style={{ margin: 0, paddingTop: 5, paddingBottom: 5, paddingLeft: headCell.paddingLeft, paddingRight: headCell.paddingRight }}
                        key={headCell.id}
                        className={(headCell.id === 'name' ? classes.stickyhh : classes.stickyh)}
                        style={{ ...((headCell.id === 'biguser' || headCell.id === 'cuser' || headCell.id === 'love') ? { borderLeft: '1px solid #dbdbdb' } : {}) }}
                        size="small"
                        align={headCell.id === 'name' ? 'left' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >{headCell.id === '0bname' || headCell.id === '1bname' || headCell.id === '2bname' || headCell.id === 'love' ? <div style={{ whiteSpace: 'nowrap' }}>{headCell.label}</div> :
                        <TableSortLabel
                            style={{ whiteSpace: 'nowrap', ...(headCell.id === 'name' ? { width: 10 } : {}), }}
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        padding: 0,
        margin: 0,
        // marginTop: theme.spacing(1),
    },
  paper: {
    width: '100%',
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
  },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        // maxHeight: 550,
        overflowX: 'auto'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },

    vvvv: {
        fontSize: 10,
        padding: 5,
        color: BColor.faircolor,
        overflow: 'visible'
    },
    button1: {
        minWidth: 110,
    },
    button2: {
        minWidth: 90,
    },
    button3: {
        minWidth: 181,
    },
    stickyc: {
    paddingLeft: 10,
    paddingRight: 5,
    width: 10,
    whiteSpace: 'nowrap',
    position: '-webkit-sticky',
    position: 'sticky',
    zIndex: 1,
    left: 0,
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
  },
    stickya: {
        background: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 10,
        top: 0,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0,
        borderBottom: '1px solid #dbdbdb'
    },
stickyh: {
    backgroundColor: theme.palette.type === "light" ? color2 : "#000000",
        position: '-webkit-sticky',
        position: 'sticky',
        zIndex: 10,
        top: 37,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0
    }, //This is header
    stickya1: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 20,
        top: 0,
        left: 0,
        paddingTop: 7,
        paddingBottom: 0,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderBottom: '0px solid #dbdbdb'
    },
    stickyhh: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        top: 37,
        left: 0,
        zIndex: 20,
        paddingTop: 0,
        paddingBottom: 7,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderTop: '0px',
        borderRight: '1px solid #dbdbdb',
        borderBottom: '1px solid #dbdbdb'
    }
}));



function BigSmallTable(props) {
    const classes = useStyles();
    const loveItems = localStorage.getItem('love_stock') != null ? JSON.parse(localStorage.getItem('love_stock')) : []

    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('');
    const [selected, setSelected] = React.useState(loveItems);
    const [page, setPage] = React.useState(props.currentpage);
    const [dense, setDense] = React.useState(props.dense);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.currentcount);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [getStock, setSavestock] = React.useState(null);

    const [opendetail, setOpendetail] = React.useState(false)
    const [stockno, setStockNo] = React.useState(null);

    const [openstock, setOpenstock] = React.useState(null);
    const [opensname, setOpenSname] = React.useState(null);
    const [concentopen, setConcentOpen] = React.useState(false);
    const [concentopen1, setConcentOpen1] = React.useState(false);
    const [lovemenu, setLovemenu] = React.useState(false)
    const myContainer = React.useRef(null);
    
    const handleLoveClick = stockNo => event => {
        setSavestock(stockNo);
        setLovemenu(true);
    };

    const handleLoveClose = () => {
        setLovemenu(false);
    };

    const handleClickOpencc = (stock_no, stockName) => event => {
        setOpenstock(stock_no)
        setOpenSname(stockName)
        setConcentOpen(true);
    };

    const handleClosecc = () => {
        setOpenstock(null)
        setOpenSname(null)
        setConcentOpen(false);
        setConcentOpen1(false);
    };

    const handleClickOpencc1 = (stock_no, stockName) => event => {
        setOpenstock(stock_no)
        setOpenSname(stockName)
        setConcentOpen1(true);
    };

    function getRowPageData(screen) {
        if (screen === 'xs')
            return [20]
        else return [10, 20, 40, 80, 150];
    }

    const rows = props.data

    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.stock_no);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        props.pageupdate(newPage, props.currentcount)
    };

    const handleChangeRowsPerPage = event => {
        setPage(0)
        setRowsPerPage(parseInt(event.target.value, 10));
        props.pageupdate(0, parseInt(event.target.value, 10))

        // setPage(0);
    };

    const openDetail = (stockno) => {
        if (props.detailUpdate != undefined) props.detailUpdate(true)
        setStockNo(stockno)
        setOpendetail(true)
    }

    const closeDetail = () => {
        if (props.closeupdate != undefined) props.closeupdate()
        if (props.detailUpdate != undefined) props.detailUpdate(false)
        setOpendetail(false)
    }


    function renderValue(value, unit, stockno, stockName) {
        let colorx = "#000205"
        let word = '持平'
        let vv = value

        if (value === "NaN") {
            colorx = BColor.faircolor
            word = '-'
            vv = "-"
        } else if (value > 0) {
            colorx = BColor.upcolorbox
            word = '增加'
        } else if (value < 0) {
            colorx = BColor.downcolorbox
            word = '減少'
            vv = -value
        } else {
            colorx = BColor.faircolor
            word = '持平'
        }
        { (value.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") }
        return <Button size="small" variant="outlined" onClick={handleClickOpencc(stockno, stockName)} style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}{vv}{unit}</Button>
    }

    function renderValue1(value, unit, stockno, stockName) {
        let colorx = "#000205"
        let word = '持平'
        let vv = value

        if (value > 0) {
            colorx = BColor.upcolorbox
            word = '增加'
        } else if (value < 0) {
            colorx = BColor.downcolorbox
            word = '減少'
            vv = -value
        } else {
            colorx = BColor.faircolor
            word = '持平'
        }
        { (value.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") }
        return <Button size="small" variant="outlined" onClick={handleClickOpencc1(stockno, stockName)} style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}{vv}{unit}</Button>
    }

    const getAllIds = () => {
        return props.data.map(row => {
            return row.market_company.stock_no
        })
    }

    return (
        <div className={classes.root}>
            <StockDetail open={opendetail} allIds={getAllIds()} handleClose={closeDetail} stockno={stockno} ismobile={props.ismobile} />
            <BigSmallList open={concentopen} handleClose={handleClosecc} stockId={openstock} stockName={opensname}></BigSmallList>
            <BigSmallList1 open={concentopen1} handleClose={handleClosecc} stockId={openstock} stockName={opensname}></BigSmallList1>
            <MyLoveList open={lovemenu} handleClose={handleLoveClose} stockno={getStock} myloveupdate={props.myloveupdate} />

            <Paper className={classes.paper}>
                <div className={classes.tableWrapper}
                    style={{ ...((localStorage.getItem('hfix') == null || localStorage.getItem('hfix') === "y") ? { maxHeight: '70vh' } : {}) }}
                >
                    <Table
                        ref={myContainer}
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >

                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            freecashupdate={props.freecashupdate}

                        />
                        <TableBody>
                            {stableSort(rows, getSorting(order, orderBy))
                                .map((row, index) => {
                                    //   const isItemSelected = isSelected(row.stock_no);

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.market_company.stock_no}
                                        >
                                            <TableCell className={classes.stickyc} style={{ borderRight: '1px solid #dbdbdb', borderBottom: '1px solid #d9d9d9' }} padding="none" size="small" align="left">
                                                <Link
    component="button"
    variant="body2"
    onClick={() => {
        openDetail(row.market_company.stock_no)
    }}
    color="inherit"
>{row.market_company.short_name}
</Link>
                                                <br />
                                                <Link
                                                    style={{ color: BColor.upcolor }}
                                                    component="button"
                                                    variant="caption"
                                                    onClick={() => openDetail(row.market_company.stock_no)}
                                                >
                                                    {row.market_company.stock_no}
                                                </Link>
                                            </TableCell>

                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} align="left">
                                                {row.chip.ymd}
                                            </TableCell> : null}

                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {(row.chip.all / 10000000).toFixed(2)}萬張
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {renderValue((row.chip.sinc / 1000).toFixed(0), '張', row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {(row.chip.user.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}人
                                                {/* {row.chip.user} */}
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="left">
                                                {renderValue(row.chip.uinc, '人', row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.chip == null || row.chip == undefined ? <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} colSpan="5" align="left">
                                            </TableCell> : null}


                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} align="right">
                                                {(row.chip.biguser.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}人
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                {(row.chip.biguper).toFixed(2)}%
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {renderValue((row.chip.bincp).toFixed(2), '%', row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {(row.chip.bigstock / 10000000).toFixed(1)}萬張
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {(row.chip.bigsper).toFixed(2)}%
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {renderValue((row.chip.bigincp).toFixed(2), '%', row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {renderValue((row.chip.b2incp).toFixed(2), '%', row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}

                                            {row.chip == null || row.chip == undefined ? <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} colSpan="7" align="left">
                                            </TableCell> : null}


                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} align="right">
                                                {(row.chip.cuser.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}人
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                {(row.chip.cuper).toFixed(2)}%
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {renderValue1((row.chip.cincp).toFixed(2), '%', row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {(row.chip.cstock / 10000000).toFixed(1)}萬張
                                            </TableCell> : null}

                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {(row.chip.csper).toFixed(2)}%
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined && row.chip.csincp != "Infinity" ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {renderValue1((row.chip.csincp).toFixed(2), '%', row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}
                                            {row.chip != null && row.chip != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                                {renderValue1((row.chip.c2incp).toFixed(2), '%', row.market_company.stock_no, row.market_company.short_name)}
                                            </TableCell> : null}

                                            {row.chip == null || row.chip == undefined ? <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} colSpan="7" align="left">
                                            </TableCell> : null}

                                            <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb', paddingLeft: 5, paddingRight: 5 }} align="center">
                                                <Button
                                                    size="small"
                                                    onClick={handleLoveClick(row.market_company.stock_no)}
                                                    variant="outlined"
                                                    style={{ width: '100%', color: BColor.faircolor }}
                                                    className={classes.button}
                                                    startIcon={<FavoriteBorder />}
                                                >
                                                    管理
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </div>
                {props.disablepage ?
                    <div><Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                    匯出
                </Button></div>
                    : <div style={{ display: "flex", justifyContent: 'flex-end' }}>
                        <Divider orientation="vertical" flexItem />
                        <Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                            匯出
                        </Button>
                        <Divider orientation="vertical" flexItem />
                        <TablePagination
                            rowsPerPageOptions={getRowPageData(props.width)}
                            component="div"
                            count={props.total}
                            rowsPerPage={props.currentcount}
                            page={props.currentpage}
                            labelRowsPerPage={'每頁'}
                            labelDisplayedRows={({ from, to, count }) => `第${from}筆，共 ${count}筆`}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        /></div>
                }
            </Paper>
        </div>
    );
}

export default withWidth()(BigSmallTable);
